import { render, staticRenderFns } from "./TypeBuildingMaterial.vue?vue&type=template&id=6db95096&"
import script from "./TypeBuildingMaterial.vue?vue&type=script&lang=js&"
export * from "./TypeBuildingMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports